import './css/bootstrap.css'
import './css/main.css'
import React from 'react'
import { render } from 'react-dom'

import SankeyApp from './lib/SankeyApp'
import { convert_data } from 'open-sankey/dist/SankeyConvert'
import { default_sankey_data } from 'open-sankey/dist/SankeyUtils'
import { AFMSankeyData } from './lib/types'
import LZString from 'lz-string'

window.React = React

type sous_filiere = { [ key : string ] : string }

declare const window: Window &
   typeof globalThis & {
    SankeyToolsStatic: boolean
    sankey: {
      sankey_data_file?:RequestInfo
      sous_filieres? : sous_filiere
      units?: string[],
      logo? : string,
      flask_header? : string,
      header? : string,
      has_header? : boolean,
      footer? : boolean,
      logo_width? : number,
      excel? : string,
      filiere?: string,
      publish?: boolean
    }
   }

window.SankeyToolsStatic = window.SankeyToolsStatic === undefined ? false : window.SankeyToolsStatic
if (!window.sankey) {
  window.sankey = {}
}
const data : AFMSankeyData = {
  ...default_sankey_data(),

  // nodeTags : {
  //   'Type de noeud' : {
  //     group_name : 'Type de noeud',
  //     tags : {
  //       produit : {
  //         name : 'produit'
  //       },
  //       secteur : {
  //         name : 'secteur'
  //       },
  //     },
  //     banner: 'none'
  //   }
  // },
  show_uncert: false,
  
  trade_sectors : [],
  trade_close_hspace: 50,
  trade_close_vspace: 20,  
  trade_hspace: 200,

  trade_left_shift: 0.45,
  trade_right_shift: 0.55,
  trade_max_shift: 0.2,

  units_names : [[]],
  tooltip_names : [],

  tags_group_idx : 1,
  tag_idx: 1,

  node_idx: 1,
  link_idx: 1
}
 
if (!window.SankeyToolsStatic) {
  const json_data = LZString.decompress(localStorage.getItem('data') as string) as string
  if (json_data !== '') {
    const new_data = JSON.parse(json_data)
    Object.assign(data, new_data)
    convert_data(data)
    data.static_sankey = window.SankeyToolsStatic ? window.SankeyToolsStatic : false
  }
  const fetchData = {
    method: 'POST'
  }
  let exemple_menu = {}
  let artefacts_menu = {}
  let formations_menu = {}
  const path = window.location.href
  const url = path + '/opensankey/sankey/menu_examples'
  fetch(url, fetchData).then(response => {
    response.text().then(text => {
      const json_data = JSON.parse(text)
      exemple_menu = json_data.exemples_menu
      formations_menu = {...json_data.exemples_menu['Formations']}
      delete json_data.exemples_menu['Formations']
      artefacts_menu = json_data.artefacts_menu
      render(
        <>
          <SankeyApp 
            initial_sankey_data={data}
            exemple_menu={exemple_menu}
            artefacts_menu={artefacts_menu}
            formations_menu={formations_menu}
          />
        </>,
        document.getElementById('react-container')
      )
    }).catch(() =>
      render(
        <>
          <SankeyApp
            initial_sankey_data={data}
            exemple_menu={{}}
            artefacts_menu={{}}
            formations_menu={{}}
          />
        </>,
        document.getElementById('react-container')
      )
    )})
} else {
  if (window.sankey.filiere) { 
    localStorage.setItem('data', LZString.compress(JSON.stringify(window.sankey.filiere)))
  }

  const json_data = LZString.decompress(localStorage.getItem('data') as string)
  //console.log(json_data)
  if (json_data !== null && json_data !== 'undefined' && json_data != '') {
    const new_data = JSON.parse(json_data)
    Object.assign(data, new_data)
    convert_data(data)
    // if (data.agregation.level === -1) {
    //   localStorage.setItem('initial_data', LZString.compress(JSON.stringify(window.sankey.filiere)))
    // }
    data.static_sankey = window.SankeyToolsStatic ? window.SankeyToolsStatic : false
  }
  render(
    <>
      <SankeyApp 
        initial_sankey_data={data}
        exemple_menu={{}}
        artefacts_menu={{}}
        formations_menu={{}}
      />
      {window.sankey.footer ? (
        <div id="copyright">
          <div className="container">
            <div className="row" style={{ 'marginTop' : '0px' }} >
              <div className="col-sm-11">
                <br/>
                <p>Réalisé par TerriFlux - <a href="https://terriflux.com">www.terriflux.fr</a></p>
              </div>
              <div className="col-sm-1">
                <img src="logo_terriflux.png" width="100"/>
              </div>
            </div>
          </div>
        </div>
      ) : (<></>)
      } 
    </>,
    document.getElementById('react-container')
  )
}